import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

export const menuAuthenticateAtom = atom({ key: 'menuAuthenticateAtom', default: [], effects_UNSTABLE: [persistAtom] });